/*
  +--------------------------------------------------------------------------------------
  | @Author:    chris<jiangqingqing@frippler.com>
  | @Title:     用户注册 API接口
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'

const jsApiHost = process.env.VUE_APP_GENERAL_API_HOST

export function usernameCheckApi(data) {
  return request({
    url: '?c=login&a=register&do=username-check',
    method: 'post',
    data: data
  })
}

export function mobileCheckApi(data) {
  return request({
    url: '?c=login&a=register&do=mobile-check',
    method: 'post',
    data: data
  })
}

export function codeSendApi(params) {
  return request({
    url: jsApiHost + '/gateway/aiot/verifycode/getCode',
    method: 'get',
    params
  })
}

export function registerApi(data) {
  return request({
    url: '?c=login&a=register&do=post',
    method: 'post',
    data: data
  })
}

export function resetApi(data) {
  return request({
    url: '?c=login&a=reset',
    method: 'post',
    data: data
  })
}

export function getQrCodeStatusApi(data) {
  return request({
    url: jsApiHost + '/gateway/aiot/register/queryqrcode',
    method: 'post',
    data
  })
}

export function getQrCodeLoginStatusApi(data) {
  return request({
    url: jsApiHost + '/gateway/aiot/login/queryqrcode',
    method: 'post',
    data
  })
}

export function getQrCodeResetPasswordStatusApi(data) {
  return request({
    url: jsApiHost + '/gateway/aiot/reset/queryqrcode',
    method: 'post',
    data
  })
}

export function getRegisterSettingApi(params) {
  return request({
    url: jsApiHost + '/gateway/aiot/register/getsetting',
    method: 'get',
    params
  })
}
